<template>
    <div>

        <div v-if="isCartEmpty" class="pb-5">
            <p class="text-3xl font-light text-center">
                {{ __('Twój koszyk jest pusty') }}
            </p>
        </div>
        <div v-else>
            <div class="items-center hidden grid-flow-col grid-cols-8 gap-4 p-6 text-base lg:grid">
                <div class="col-span-4"></div>
                <div>
                    <span>{{ __('Cena jednostkowa') }}</span>
                </div>
                <div class="col-span-2">
                    <span>{{ __('Liczba sztuk') }}</span>
                </div>
                <div>
                    <span>{{ __('W sumie') }}</span>
                </div>
            </div>

            <div class="border-t border-l border-r border-grey-200 rounded mb-6 high-contrast:border-yellow-300">
                <cart-item
                    v-for="(item, index) in cartData.items" v-bind:key="`cart-item-${index}`"
                    :item="item"
                    :itemError="getItemError(index)"
                    @remove-from-cart="removeFromCart"
                    @change-item-quantity="changeItemQuantity"
                    @show-message="showMessage"
                />
            </div>

            <div class="grid items-center grid-cols-1 gap-4 sm:pr-6 text-base text-center sm:grid-cols-4 lg:grid-cols-8 sm:text-left">
                <div class="sm:col-span-4 lg:col-span-5 pb-4">
                    <div class="flex items-center flex-col-reverse sm:flex-row">
                        <input-text
                            v-model="cartData.promotional_code"
                            name="promotional_code"
                            :label="__('Kod promocyjny')"
                            class="w-full sm:w-auto"
                        />
                        <div class="sm:pl-3">
                            <p class="text-base leading-0 text-orange">{{ __('Masz kod promocyjny? Wykorzystaj go!') }}</p>
                            <p class="text-sm leading-0">{{ __('Rabat zostanie naliczony w podsumowaniu zamówienia.') }}</p>
                        </div>
                    </div>
                </div>
                <div v-if="isPolishVersion" class="sm:col-span-4 lg:col-start-6">
                    <div class="grid grid-cols-1 sm:grid-cols-4 lg:grid-cols-3 gap-4 mb-4 sm:mb-1">
                        <div class="sm:col-span-3 lg:col-span-2">
                            <p>{{ cartData.realization_time_label }}</p>
                        </div>
                        <div>
                            <span class="text-2xl font-bold font-secondary">{{ cartData.realization_time }}</span>
                        </div>
                    </div>
                    <div class="grid grid-cols-1 sm:grid-cols-4 lg:grid-cols-3 gap-4">
                        <div class="sm:col-span-3 lg:col-span-2">
                            <p>{{ __('Koszt produktów (bez kosztów dostawy)') }}</p>
                        </div>
                        <div>
                            <span class="text-2xl font-bold font-secondary">{{ cartData.total_price | price }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="text-center">
                <button
                    class="flex items-center text-white justify-center block w-full px-4 py-2 mx-auto my-8 text-xl rounded bg-orange lg:w-1/3 font-secondary high-contrast:bg-yellow-300 high-contrast:text-black"
                    @click="goToNextStep"
                >
                    <span>{{ __('Wybierz płatność i sposób dostawy') }}</span>
                    <arrow-right class="inline w-4 ml-4 fill-white high-contrast:fill-black"></arrow-right>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import CartItem from '@/front/components/Cart/CartItem';
import ArrowRight from '@/front/components/Icons/ArrowRight';
import InputText from "@/front/components/Inputs/Text";

export default {
    components: {
        CartItem,
        ArrowRight,
        InputText,
    },
    props: {
        isActionInProgress: Boolean,
        stockError: {
            stockError: Object,
            required: false,
        },
        cartData: {
            cartData: Object,
            required: true,
        }
    },
    data() {
        return {
            itemError: {},
            locale: window.Laravel.locale
        };
    },
    computed: {
        isCartEmpty() {
            return _.isEmpty(this.cartData);
        },
        isPolishVersion() {
            return this.locale == 'pl';
        }
    },
    methods: {
        getItemError(index){
            return  _.get(this.stockError.errors, "items." + index + ".quantity", {});
        },
        goToNextStep(){
            this.$emit('toggle-preloader');
            this.$emit('go-to-delivery', this.cartData);
        },
        removeFromCart(id) {
            this.$emit('toggle-preloader');

            axios
                .post(route("json.cart.remove_item"), {
                    id: id
                })
                .then((response) => {
                    this.$emit('toggle-preloader');
                    this.showMessage(_.get(response, "data.message", ""));
                })
                .catch((error) => {
                    console.log(error);
                })
                .then(() => {
                    this.$eventBus.$emit("refresh-header-cart");
                    this.refreshCartData();
                });
        },
        changeItemQuantity(id, quantity) {
            this.$emit('toggle-preloader');

            axios
                .post(route("json.cart.update_item"), {
                    id: id,
                    quantity: quantity
                })
                .then((response) => {
                    this.$emit('toggle-preloader');
                    this.$emit(
                        'show-message',
                        _.get(response, "data.message", ""),
                        _.get(response, "data.icon", "success")
                    );
                })
                .catch((error) => {
                    console.log(error);
                })
                .then(() => {
                    this.$eventBus.$emit("refresh-header-cart");
                    this.refreshCartData();

                });
        },
        refreshCartData() {
            this.$emit("load-cart-data");
        },
        showMessage(message){
            this.$emit('show-message', message);
        }
    },
};
</script>
